import React from "react";

export const BlueRightArrowIcon = (props) => {
  return (
    <>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M11.3233 10.1732L7.43251 6.40429C7.1959 6.17509 7.1959 5.79556 7.43251 5.56636C7.65871
         5.34724 8.018 5.34724 8.2442 5.56636L13 10.1732L8.2442 14.7801C8.018 14.9992 7.65871 14.9992 7.43251 14.7801C7.1959 14.5509 7.1959 14.1713 
         7.43251 13.9421L11.3233 10.1732Z" fill="#004F9F" stroke="#004F9F" strokeWidth="0.5"/>
      </svg>
    </>
  );
};
